import { Logo } from "@motleyhand/design"

type Props = {
  variant?: "full" | "glyph" | "wordmark"
  size?: string | number
  className?: string
}

/** The shared Logo bound to PromptJuggler's own wordmark. */
export default function AppLogo(props: Props) {
  return props.variant === "glyph" ? (
    <Logo {...props} variant="glyph" />
  ) : (
    <Logo {...props} lead="Prompt" accent="Juggler" />
  )
}
